import { APIDecoratorWithBaseURI } from '../../Service/api'

export interface useWithdrawProps {
  fetcher: (id: string) => Promise<any>
}

export interface CourtesyRequestProps {
  quantity: number
  event_id: number
  ticket_id: number
  ticket_lote: number
  ticket_type: string
  user_id: number
  user_name: string
  user_email: string
  user_cpf: string
  pdv_serial: string
}

export interface CourtesySaleRequesteResponse {
  success: boolean
  mensagem: string
}

export const useCourtesyRequest = (payload: CourtesyRequestProps) => {
  const useCourtesyRequestFetcher = async () => {
    return await APIDecoratorWithBaseURI().post(
      'producer/app/v2/courtesy/sale',
      {
        ...payload,
      }
    )
  }

  return {
    useCourtesyRequestFetcher,
  }
}
